<template>
  <div class="d-flex align-items-center" style="height: 1.5rem;">
    <div v-if="value?.imagePath" class="forgeron-resource-image" style="width: 1.5rem; text-align: center; height: 100%;">
      <image-element :value="value?.imagePath" style="max-height: 1rem; max-width: 1.5rem; margin-top: -0.125rem;"></image-element>
    </div>
    <string-color-icon
      v-if="!value?.imagePath"
      :icon-class="value?.iconClass ?? (value ? 'fa-solid fa-empty-set' : 'fa fa-ban')"
      :shadow="false"
      :value="value?.color ?? value?.title"
    ></string-color-icon
    >&nbsp;
    <Link
      v-if="isLinkable(route, routePrefix)"
      :href="route(`${routePrefix}.${value?.resource}.show`, getParams())"
      :class="{ 'active': route(`${routePrefix}.${value?.resource}.show`, getParams()).endsWith($page.url) }"
    >
      {{ displayValue() }}
    </Link>
    <span v-else :class="{ 'text-muted': !value?.title }">
      {{ displayValue() }}
    </span>
    <small v-if="showId === 'true' && value?.id" class="text-muted ps-1"> (ID: {{ value?.id }}) </small>
  </div>
</template>

<script>
import StringColorIcon from '@kanrisha/components/Icons/StringColorIcon';
import { Link } from '@inertiajs/vue3';
import ImageElement from "@kanrisha/components/Elements/Display/ImageElement";

export default {
  components: {
    ImageElement,
    StringColorIcon,
    Link,
  },
  props: {
    value: { type: Object, default: () => {} },
    showId: { type: [Boolean, String], default: 'true' },
    showLink: { type: [Boolean, String], default: 'true' },
  },
  setup(props) {
    const displayValue = () => {
      if (typeof props.value?.title === 'undefined') {
        return '(kein Zugriff)';
      }

      if (props.value.title === '' || props.value.title === null) {
        return '(leer)';
      }

      return props.value?.title;
    };

    const getParams = () => {
      let params = {};
      params[props.value?.parameter] = props.value?.id;
      return params;
    };

    const isLinkable = (route, routePrefix) => {
      if (!props.value?.id || !props.showLink) {
        return false;
      }

      return route().has(`${routePrefix}.${props.value?.resource}.show`);
    };

    return {
      displayValue,
      getParams,
      isLinkable,
    };
  },
};
</script>
